import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDiscountType, IRegion } from '../../models/benefit-plus-result';
import { IBenefitsPlusLobbyResult } from '../../models/lobby-result';
import { BenefitsPlusService } from '../../services/benefits-plus.service';
import { a11yFix } from 'ClientApp/app/shared/utils/a11y.utils';

@Component({
    selector: 'app-benefits-plus-filters',
    templateUrl: './benefits-plus-filters.component.html',
    styleUrls: ['./benefits-plus-filters.component.scss']
})
export class BenefitsPlusFiltersComponent implements OnInit {
    @Input() data: IBenefitsPlusLobbyResult;
    @Output() loadBenefits: EventEmitter<any> = new EventEmitter<any>();
    sortText: string = null;
    openPopup: string = null;

    constructor(public benefitsSvc: BenefitsPlusService) { }

    ngOnInit(): void {

        // a11yFix().dialog(".drop-button-wrapper", {
        //     selectors:{
        //            dialog: ".drop-button-wrapper",
        //             trigger:".drop-button-wrapper", // not relative to container
        //             // closeBtn?: string;  // relative to container
        //             // heading?: string;  // relative to container
        //             // textContent?: string;  // relative to container
        //     },
        //     type:  "non_modal" // modal is for a dialog, non modal is for a dropdown
        //     });

        a11yFix().button(".drop-down li a", {
            selectors: {
                element: ".drop-down li a",
            }
        });

        a11yFix().listbox('#benefitsTypeTrigger', {
            selectors: {
                trigger: '#benefitsTypeTrigger',
                listbox: '#benefitsTypeDropdown',
                options: '.option',
                label: '.drop-down-label'
            }
        })
        a11yFix().listbox('#benefitsRegionTrigger', {
            selectors: {
                trigger: '#benefitsRegionTrigger',
                listbox: '#benefitsRegionDropdown',
                options: '.option',
                label: '.drop-down-label'
            }
        })
        a11yFix().listbox('#benefitsSortTrigger', {
            selectors: {
                trigger: '#benefitsSortTrigger',
                listbox: '#benefitsSortDropdown',
                options: '.option',
                label: '.drop-down-label'
            }
        })

    }

    loadFilteredResult() {
        this.loadBenefits.emit({
            type: this.benefitsSvc.type,
            region: this.benefitsSvc.region,
            sort: this.benefitsSvc.sort
        });
    }

    filterByType(type: IDiscountType) {
        this.benefitsSvc.type = type;
        this.loadFilteredResult();
        this.setOpenPopup('type');
    }

    filterByRegion(region: IRegion) {
        this.benefitsSvc.region = region;
        this.loadFilteredResult();
        this.setOpenPopup('region');
    }

    sortBenefits(sort) {
        this.benefitsSvc.sort = sort;
        this.loadFilteredResult();
        this.setOpenPopup('sort');
    }

    setOpenPopup(popup: string) {
        this.openPopup = this.openPopup != popup ? popup : null;
    }
}
